var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipedrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 254,
    viewBox: "0 0 254 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 254,
    height: 254,
    rx: 127,
    fill: "#017737"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.68 105.85C196.68 140.21 174.51 163.71 142.81 163.71C127.74 163.71 115.32 157.5 110.67 149.74L110.89 157.72V206.93H78.53V79.69C78.53 77.92 78.09 77.47 76.09 77.47H65V50.43H92.05C104.46 50.43 107.57 61.07 108.45 65.73C113.33 57.53 126.18 48 144.36 48C175.62 47.99 196.68 71.26 196.68 105.85ZM163.65 106.07C163.65 87.67 151.68 75.04 136.6 75.04C124.19 75.04 110.22 83.24 110.22 106.3C110.22 121.37 118.64 137.11 136.16 137.11C149.02 137.1 163.65 127.79 163.65 106.07Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipedrive);
export default __webpack_public_path__ + "static/media/pipedrive.ce82e35b3002732d5952eec845bd4be4.svg";
export { ForwardRef as ReactComponent };